export default __webpack_public_path__ + "static/media/060-bank.c029c172.svg";